import { render, staticRenderFns } from "./CaseOverviewCard.vue?vue&type=template&id=b01f76be&scoped=true&"
import script from "./CaseOverviewCard.vue?vue&type=script&lang=js&"
export * from "./CaseOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./CaseOverviewCard.vue?vue&type=style&index=0&id=b01f76be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01f76be",
  null
  
)

export default component.exports